import { render, staticRenderFns } from "./Top10AlacakliCariListesi.vue?vue&type=template&id=b8a442c8&scoped=true"
import script from "./Top10AlacakliCariListesi.vue?vue&type=script&lang=js"
export * from "./Top10AlacakliCariListesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a442c8",
  null
  
)

export default component.exports